// @ts-nocheck
import logo from "../assets/images/rifat/logo-270.png";

/**
 * Single place to configure this venue.
 *
 * Everything brand- and feature-specific lives here, so pointing the app at a different
 * restaurant means editing this file (plus src/data/menu.js) and nothing else.
 *
 * Details below come from rifatpeshkatari.com.
 */

const businessConfig = {
    // --- Identity -------------------------------------------------------
    name: "Rifat Peshkatari",
    legalName: "Hotel-Restorant Rifat Peshkatari",
    // badge and tagline are the fallback wording, used when a language has no
    // "businessBadge" / "businessTagline" key in src/translation/*.json. Editing them
    // here is enough for a venue that shows the same line in every language; add the
    // keys to translate them.
    // Small pill above the welcome headline
    badge: "Restorant Peshku • Durrës",
    tagline: "Peshk i freskët, mikpritje shqiptare, rehati buzë detit",
    logo,
    icon: "🐟",

    // --- Contact --------------------------------------------------------
    phone: "+355 69 205 3588",
    // Digits only, used for tel: and wa.me links
    phoneRaw: "355692053588",
    address: "Lagja 13, Plazh, Rruga Pavarësia, Durrës",
    mapsUrl: "https://maps.google.com/?q=Rifat+Peshkatari+Durres",
    website: "https://rifatpeshkatari.com",
    hours: "10:00 - 23:00",
    social: {
        facebook: "https://www.facebook.com/p/Rifat-Peshkatari-Restorant-100071108896838/",
        instagram: "https://www.instagram.com/rifatpeshkatarirestorant/",
    },

    // --- Hotel ----------------------------------------------------------
    // Drives the banner at the foot of the home page. Set to null to drop the banner -
    // useful if this config is ever pointed at a restaurant with no rooms.
    // bookingUrl is the plain hotel page: the "Rezervo tani" link on rifatpeshkatari.com
    // carries a browsing-session token that would go stale here.
    hotel: {
        bookingUrl: "https://www.booking.com/hotel/al/rifat-peshktari.html",
    },

    // --- Look -----------------------------------------------------------
    // Taken from the logo
    brandColor: "#3F3F97",

    // --- Prices ---------------------------------------------------------
    currency: "Lekë",
    // The printed menu has no euro prices, so the euro line stays hidden.
    showEuroPrice: false,

    // --- Menu source ----------------------------------------------------
    // "api" loads the menu from the Click server, as the Hira and Vivas apps do.
    // src/data/menu.js stays as the backup: it is shown while businessId is empty, and
    // whenever the server fails, takes more than 8 seconds or has no dishes for us.
    // "static" skips the server and always shows src/data/menu.js.
    // The server has no field for a price unit or a category note: put "për kg" in a
    // dish's size, and the note in the category's description.
    menuSource: "api",
    // Rifat Peshkatari's business on the server, whose menu was copied from src/data/menu.js
    // on 2026-09-19. Emptying it goes back to the bundled menu alone.
    businessId: "7",
    api: {
        // Not clickapp.win: a Cloudflare Worker answers there now, with an HTML page.
        url: "https://api.clickapp.win",
    },

    // --- Hiding dishes --------------------------------------------------
    // Ids listed here disappear from the home rows, the menu and search. Use it for
    // anything out of season; nothing needs deleting from src/data/menu.js.
    // They are the ids of whichever menu is showing - the server numbers its dishes
    // differently from src/data/menu.js.
    //   hiddenItemIds: [105, 315],
    hiddenItemIds: [],
    // Same, but for a whole category by its id.
    hiddenCategoryIds: [],
};

export default businessConfig;
